import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import CircularProgress from '@mui/material/CircularProgress';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        margin: 8,
        padding: 8,
    }
});

const Loader = ({ classes }) => (
    <div className={classes.root}>
        <CircularProgress />
    </div>
);

Loader.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Loader);
